import {Col, Row,} from "antd";
import React, {useEffect, useState} from "react";
import {WdiSelect} from "@/components/WdiControls/WdiSelect";


export enum ProductCustomizeType {
  REACH = 1,
  REBATE = 2,
}

export const ProductCustomizeValueMap = new Map<ProductCustomizeType, string>([
  [ProductCustomizeType.REACH, "达量"],
  [ProductCustomizeType.REBATE, "返利"]
]);

export type ProductCustomizeInputValue = {
  typeId?: ProductCustomizeType
}


type RebateStandardProductCustomizeInputProps = {
  value?: ProductCustomizeInputValue,
  onChange?: (value: ProductCustomizeInputValue) => void
}


export const RebateStandardProductCustomizeInput: React.FC<RebateStandardProductCustomizeInputProps> = (props) => {
  const [customizeValue, setCustomizeValue] = useState<ProductCustomizeInputValue>({});


  useEffect(() => {
    setCustomizeValue(props.value??{});
  }, [props.value])


  return (<Row gutter={[16, 8]}>
    <Col span={24}>
      <WdiSelect
        value={customizeValue?.typeId}
        options={Array.from(ProductCustomizeValueMap.entries()).map(item => {
          return {
            value: item[0],
            label: item[1]
          }
        })}
        onChange={(value) => {
          setCustomizeValue({
            typeId: value,
          })
        }}
        onBlur={() => {
          props.onChange?.(customizeValue)
        }}
      />
    </Col>
  </Row>)
}



